document.addEventListener('click', (event) => {
  const openFacets = document.querySelectorAll('.tc-facets__desktop details[open]');

  openFacets.forEach((details) => {
    if (!details.contains(event.target)) {
      details.removeAttribute('open');
    }
  });
});

document.addEventListener('toggle', (event) => {
  const target = event.target;

  if (!target.matches('.tc-facets__desktop details.js-filter') || !target.open) return;

  document.querySelectorAll('.tc-facets__desktop details.js-filter[open]').forEach((details) => {
    if (details !== target) {
      details.removeAttribute('open');
    }
  });
}, true);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.tc-facets__desktop details[open]').forEach((details) => {
    details.removeAttribute('open');
  });
});